/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InstallationsResponseGetRecordsList } from '../../models/installations-response-get-records-list';

export interface DevicesControllerGetInstallations$Params {

/**
 * Project id.
 */
  id: string;

/**
 * Optional fulltext filter used for searching installations.
 */
  search?: string;
}

export function devicesControllerGetInstallations(http: HttpClient, rootUrl: string, params: DevicesControllerGetInstallations$Params, context?: HttpContext): Observable<StrictHttpResponse<InstallationsResponseGetRecordsList>> {
  const rb = new RequestBuilder(rootUrl, devicesControllerGetInstallations.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('search', params.search, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<InstallationsResponseGetRecordsList>;
    })
  );
}

devicesControllerGetInstallations.PATH = '/planning-projects/v1-develop/devices/installations/{id}';
